module.exports = __webpack_public_path__ + "static/media/green3.b8f9bacb.jpg";